import React, { Fragment } from 'react'
import HeaderBotton from '../../../components/HeaderBottom'
import HeaderTop from '../../../components/HeaderTop'
import Breadcumb from '../../../components/Breadcumb'
import Service from '../../../components/Service'
import About from '../../../components/About'
import ServiceArea from '../../../components/ServiceArea'
import Testmonial from '../../../components/Testmonial'
import TeamMember from '../../../components/TeamMember'
import CounterArea from '../../../components/CounterArea'
import BlogArea from '../../../components/BlogArea'
import NewsLetter from '../../../components/Newsletter'
import FooterArea from '../../../components/FooterArea'
// images
import about from '../../../images/about/2.jpg'
import breadcumb from '../../../images/breadcumb/1.jpg'

import './style.scss'

const aboutText = [
  {
    text: 'Dana Shimal for Lighting General Trading Private Limited is a dynamic and trusted name in the lighting industry, dedicated to illuminating spaces with innovation, quality, and style. Established with a vision to redefine lighting solutions, we specialize in sourcing, supplying, and distributing a diverse range of premium lighting products tailored to meet the evolving needs of residential, commercial, and industrial clients. Our commitment to excellence is reflected in our curated selection of energy-efficient, aesthetically pleasing, and technologically advanced lighting systems, sourced from globally renowned manufacturers.',
  },
  {
    text: 'As a customer-centric organization, we pride ourselves on delivering tailored solutions, seamless project execution, and a reliable supply chain to ensure client satisfaction at every stage. Our team of experienced professionals combines technical expertise with a passion for creativity, helping clients transform their spaces into inspiring environments. Sustainability lies at the heart of our operations, as we strive to promote eco-friendly lighting solutions that reduce energy consumption without compromising on design or performance.',
  },
  {
    text: 'At Dana Shimal for Lighting, we believe lighting is more than functionality—it’s an art that shapes ambiance and elevates experiences. Partner with us to brighten your world with cutting-edge lighting solutions that blend innovation, reliability, and elegance.',
  },
]

const services = [
  {
    icon: 'flaticon-parents',
    title: 'Family Law',
    content: 'There are many variations of passages of Lorem ',
  },
  {
    icon: 'flaticon-wounded',
    title: 'Personal Injury',
    content: 'There are many variations of passages of Lorem ',
  },
  {
    icon: 'flaticon-employee',
    title: 'Business Law',
    content: 'There are many variations of passages of Lorem ',
  },
  {
    icon: 'flaticon-thief',
    title: 'Criminal Law',
    content: 'There are many variations of passages of Lorem ',
  },
  {
    icon: 'flaticon-university-graduate-hat',
    title: 'Education Law',
    content: 'There are many variations of passages of Lorem ',
  },
  {
    icon: 'flaticon-house',
    title: 'Real Estate Law',
    content: 'There are many variations of passages of Lorem ',
  },
]

const breadcumbMenu = [{ name: 'Home', route: '/' }, { name: 'About us' }]

const AboutPage = () => {
  return (
    <Fragment>
      <header className="headerArea">
        {/* <HeaderTop className="headerTop" /> */}
        <HeaderBotton className="headerBottomArea headerBottomAreaStyelTwo" />
      </header>
      <Breadcumb
        className="breadcumbArea"
        title="About Us"
        breadcumbMenu={breadcumbMenu}
        background={breadcumb}
      />
      {/* <Service className="serviceArea mt-0" /> */}
      <About
        className="aboutArea aboutAreaStyleTwo"
        title="Dana Shimal"
        subTitle="About us"
        images={about}
        orderLast="order-last"
        videoId="XxVg_s8xAms"
        pragraphs={aboutText}
      />
      {/* <ServiceArea
                className="ourServiceArea ourServiceAreaStyleTwo"
                title="How Can We Help You"
                subTitle="Area Of Practice"
                services={services}
            /> */}
      {/* <Testmonial
                className="testmonialArea pt100"
            /> */}
      {/* <CounterArea
                fullWidth={true}
                className="counterArea counterAreaStyleTwo"
            /> */}
      {/* <TeamMember
                title="Qualified Attorneys "
                subTitle="Meet Our Experts"
                className="teamArea"
                slider={true}
            /> */}
      /
      {/* <NewsLetter
                className="newsLetterArea"
            /> */}
      <FooterArea />
    </Fragment>
  )
}
export default AboutPage
